






















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { GenericItem } from '@/models/items/generic-item-model';
import { UserModule } from '@/store/modules/user';
import { ListModelUtil } from '@/model-utils/list-model-util';
import { ListModel } from '@/models/list-model';

import ListCardSmallWide from '@/components/list-cards/ListCardSmallWide.vue';
import { ItemModelUtil } from '@/model-utils/item-model-util';
import { AbstractItemModel } from '../../models/items/abstract-item-model';

@Component({ components: { ListCardSmallWide } })
export default class AddItem_Step4 extends Vue {
  public showNewListForm: boolean = false;
  @Prop(GenericItem) public item: GenericItem;
  public lists: ListModel[] = [];
  public listTitle: string = '';

  public created() {
    const self = this;
    ListModelUtil.watchListsFromUserId(
      UserModule.currentUserId,
      lists => (self.lists = lists)
    );
  }

  public async addItemToList(list: ListModel) {
    const savedItem: AbstractItemModel = await ItemModelUtil.addItemToList(
      this.item,
      list,
      UserModule.userProfile
    );
    this.$router.push(savedItem.link);
  }

  public async onMakeNewListSubmit() {
    if (!this.listTitle) {
      // this.$toasted.error('Missing list name');
    } else {
      const list = await ListModelUtil.writeWithDefaultsList(
        this.listTitle,
        UserModule.userProfile
      );
      this.addItemToList(list);
    }
  }
}
